<template>
  <div class="container-fluid py-4 px-4 ">

    <div class="border border-1 rounded-3 p-3 mb-2 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-files display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
           VACACIONES
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            LISTA DE VACIONES
          </p>
        </div>
      </div>
    </div>
 <div class="table-responsive mx-2 mt-2">
        <table class="table table-bordered">
          <thead class="reducirTamaño">
            <tr class="bg-solimano text-white text-center text-nowrap">
             <th>N° </th>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
              <th>DESCRIPCION</th>
              <th>FECHA INICIO</th>
              <th>FECHA FIN </th>
            </tr>
          </thead>
          <tbody>

           
            <tr v-if="loading">
              <td colspan="5" class="text-center align-middle" style="height: 260px;">
                <div class="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                  <div class="spinner-border text-warning" style="width: 3.5rem; height: 3.5rem;"></div>
                  <div class="mt-3 text-secondary fw-semibold fs-5">Filtrando información...</div>
                </div>
              </td>
            </tr>

          </tbody>

        </table>
      </div>

  </div>
</template>

<script>


export default {
  name: 'SolimanoVacaciones',
  components:{
   
  },
  data() {
    return {
      
    };
  },

  mounted() {
    this.cambiarEstadoNavbar()
  },

  methods: {
    
  },
};
</script>

<style scoped>
/* .acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-right: 0.5rem !important;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
} */
 .boton-estiloCuadrado {
  padding: 0.20rem 0.55rem;
  cursor: pointer;
}

.tabla-estiloCompreso {
  padding: 0.30rem 0.55rem;

}

.bg-solimano {
  background: #1565C0;
}


.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.reducirTamaño {
  font-size: 0.65rem;
}
</style>